import React from 'react';
import {
  formatCoinsFromDollars,
  formatDate,
  formatDollarAmount,
  getTransactionLabel,
} from '../services/formatters';

function DashboardPage({ user, transactions, loading, error, onAddCoins, onLogout }) {
  const balanceCoins = formatCoinsFromDollars(user?.balance || 0);
  const visibleTransactions = Array.isArray(transactions)
    ? transactions.filter(
        (item) => item?.type === 'deposit' || item?.type === 'welcome_bonus'
      )
    : [];

  return (
    <main className="page-shell dashboard-shell">
      <section className="dashboard-header">
        <div>
          <span className="eyebrow">Account dashboard</span>
          <h1>{user?.username ? `${user.username}'s wallet` : 'Wallet'}</h1>
          <p className="dashboard-subtitle">
            Review coin balance
          </p>
        </div>
      </section>

      <section className="dashboard-metrics">
        <article className="metric-card balance-card">
          <span className="metric-label">Current balance</span>
          <strong>{balanceCoins}</strong>
        </article>
      </section>

      <section className="dashboard-panel">
        <div className="panel-header">
          <div>
            <h2>Transactions</h2>
          </div>
          <button className="nav-link danger-link" onClick={onLogout}>
            Log out
          </button>
        </div>

        {loading ? (
          <div className="loading-state">Loading transactions...</div>
        ) : error ? (
          <div className="notice error-notice">{error}</div>
        ) : visibleTransactions.length === 0 ? (
          <div className="empty-state">
            <h3>No transactions yet</h3>
            <p>Your coin history will appear here after purchases or spending.</p>
          </div>
        ) : (
          <div className="transaction-list">
            {visibleTransactions.map((item) => {
              const amount = Number(item.amount || 0);
              const positive = amount >= 0;

              return (
                <div className="transaction-row" key={item.id}>
                  <div className="transaction-copy">
                    <strong>{getTransactionLabel(item)}</strong>
                    <span>{formatDate(item.created_at)}</span>
                  </div>

                  <div className="transaction-amount-block">
                    <strong className={positive ? 'amount-positive' : 'amount-negative'}>
                      {positive ? '+' : '-'}
                      {formatCoinsFromDollars(Math.abs(amount))}
                    </strong>
                    <span>{formatDollarAmount(Math.abs(amount))}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </main>
  );
}

export default DashboardPage;